// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-22279b48]{height:100%;max-width:200px}.card-content[data-v-22279b48]{padding:.5rem;line-height:normal}.card-image[data-v-22279b48]{padding:1rem}.truncate[data-v-22279b48]{overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:block-axis;vertical-align:middle;min-height:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
